const ACTIVE_DEPOSIT_STATUS = [
    'ACTIVATION_PENDING',
    'ACTIVE',
    'AWAITING_CANCELLATION',
    'PAYOUT_IN_PROGRESS'
];
export const depositBalanceLabel = ({ status, type }) => {
    if (ACTIVE_DEPOSIT_STATUS.includes(status) || type === 'SAVINGS_ACCOUNT') {
        return 'Balance';
    }
    return 'Balance paid out';
};
